import * as React from 'react'
import Report from '../../model/Report'
import { Table, Button, ButtonGroup, Container, Badge } from 'react-bootstrap'
import { downloadReportUrl } from '../../rest-api/Report-api'
import { ReportGroupSelectionContainer } from '../ReportGroupSelection/ReportGroupSelectionContainer'
import { ReportRouteProps } from '../Router/Router'
import ReportGroup from '../../model/ReportGroup'
import Market from '../../model/Market'
import { FaBolt, FaTrashAlt, FaPencilAlt, FaPlus, FaDownload } from 'react-icons/fa'

export interface StateProps {
  reportsLoading: boolean
  reportGroupsLoading: boolean
  reportList: Report[]
  error: string
  reportGroup?: ReportGroup
  marketKey: string
  reportGroupKey: string
  marketsLoading: boolean
  markets?: _.Dictionary<Market>
}
export interface DispatchProps {
  reportDelete: (market: string, report: Report) => void
  reportReplace: (market: string, report: Report, file: File) => void
  reportsLoad: (market: string, reportGroup: string) => void
}
type Props = StateProps & DispatchProps & ReportRouteProps;

const getExtension = (fileName: string) => {
  var fileParts = fileName.split('.')
  if (fileParts.length > 1) {
    return fileParts[fileParts.length - 1]
  } else {
    return null
  }
}

export class ReportsListComponent extends React.Component<Props, {}> {
  componentDidUpdate(previousProps: Readonly<Props>) {
    if (
      previousProps.marketKey !== this.props.marketKey ||
      previousProps.reportGroupKey !== this.props.reportGroupKey
    ) {
      this.props.reportsLoad(this.props.marketKey, this.props.reportGroupKey)
    }
  }

  componentDidMount() {
    if (this.props.marketKey && this.props.reportGroupKey) {
      this.props.reportsLoad(this.props.marketKey, this.props.reportGroupKey)
    }
  }

  render() {
    return (
      <div>
        <ReportGroupSelectionContainer
          market={this.props.marketKey}
          reportGroup={this.props.reportGroup && this.props.reportGroup.key}
        />
        {this.props.marketKey && this.props.reportGroupKey ? (
          this.props.error ? (
            <div className="alert alert-danger">{this.props.error}</div>
          ) : this.props.reportsLoading ? (
            <Badge>
              <FaBolt /> Loading reports...
            </Badge>
          ) : this.props.marketsLoading ? (
            <Badge>
              <FaBolt /> Loading markets...
            </Badge>
          ) : (
            <Container>
              {this.props.reportGroupsLoading ? (
                <div>
                  <Badge>
                    <FaBolt /> Loading report Groups...
                  </Badge>
                </div>
              ) : this.props.reportGroup ? (
                <h5>
                  Reports for {this.props.markets && this.props.markets[this.props.marketKey].name}:{' '}
                  {this.props.reportGroup.name}
                </h5>
              ) : (
                <p className="alert alert-danger">Unknown report group</p>
              )}
              <Table>
                <tbody>
                  <tr>
                    <th>File Name</th>
                    <th style={{ minWidth: '150px' }}>Date Uploaded</th>
                    <th>Report Group</th>
                    <th>Site</th>
                    <th>Uploaded By</th>
                    <th>Period</th>
                    <th>Start Date</th>
                    <th style={{ minWidth: '134px' }}>
                      <Button
                        title="Add Report"
                        onClick={() =>
                          this.props.history.push(
                            `/reports/${this.props.marketKey}/${this.props.reportGroupKey}/new`
                          )
                        }
                      >
                        <FaPlus />
                      </Button>
                    </th>
                  </tr>
                  {this.props.reportList.map(report => {
                    return (
                      <tr key={report.id}>
                        <td>{report.fileName}</td>
                        <td>{report.dateUploaded.toLocaleString()}</td>
                        <td>{report.reportGroup}</td>
                        <td>{report.site}</td>
                        <td>{report.uploadedBy}</td>
                        <td>{report.period}</td>
                        <td>{report.startDate ? report.startDate.toLocaleDateString() : null}</td>
                        <td>
                          <ButtonGroup>
                            <Button
                              title="Delete"
                              onClick={() => {
                                if (
                                  window.confirm(
                                    `Are you sure you want to delete ${report.fileName}?`
                                  )
                                ) {
                                  this.props.reportDelete(this.props.marketKey, report)
                                }
                              }}
                            >
                              <FaTrashAlt />
                            </Button>
                            <Button
                              title="Replace"
                              onClick={() => {
                                var element = document.getElementById(`file-upload-${report.id}`)
                                if (element) {
                                  element.click()
                                }
                              }}
                            >
                              <FaPencilAlt />
                            </Button>
                            <Button
                              title="Download"
                              href={downloadReportUrl(this.props.marketKey, report.id)}
                            >
                              <FaDownload />
                            </Button>
                          </ButtonGroup>
                          <form>
                            <input
                              id={`file-upload-${report.id}`}
                              accept=".pdf"
                              type="file"
                              style={{ display: 'none' }}
                              onChange={e => {
                                if (e.target.files && e.target.files.length === 1) {
                                  var userCancelled = false
                                  var extension = getExtension(e.target.files[0].name)
                                  if (extension && extension.toLowerCase() !== 'pdf') {
                                    if (
                                      !window.confirm(
                                        'Selected file is not a pdf file, ' +
                                          'are you sure you want to upload this?'
                                      )
                                    ) {
                                      userCancelled = true
                                    }
                                  }
                                  var existingExtension = getExtension(report.fileName)
                                  if (
                                    !userCancelled &&
                                    extension &&
                                    existingExtension &&
                                    extension.toLowerCase() !== existingExtension.toLowerCase()
                                  ) {
                                    if (
                                      !window.confirm(
                                        'Selected file is not the same type as existing file, (' +
                                          existingExtension +
                                          '), are you sure you want to replace it?'
                                      )
                                    ) {
                                      userCancelled = true
                                    }
                                  }
                                  if (!userCancelled) {
                                    this.props.reportReplace(
                                      this.props.marketKey,
                                      report,
                                      e.target.files[0]
                                    )
                                  }
                                  // tslint:disable-next-line:no-any
                                  var parent: any = e.target.parentNode
                                  if (parent) {
                                    // This clears the selected file, so if the user selects the same file
                                    // twice, it will still kick off the change event and attempt to upload
                                    parent.reset()
                                  }
                                }
                              }}
                            />
                          </form>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </Container>
          )
        ) : null}
      </div>
    )
  }
}
